export const DEFAULT_USERNAME_SPLITTER = '_';

export function composeCompanyUsername(companyName, localUsername, splitter) {
  const prefix = String(companyName || '').trim();
  const local = String(localUsername || '').trim();
  const sep = String(splitter || DEFAULT_USERNAME_SPLITTER);
  if (!local) return '';
  const localNorm = local.toLowerCase();
  if (!prefix) return localNorm;
  const lead = `${prefix}${sep}`;
  if (localNorm.startsWith(lead.toLowerCase())) return localNorm;
  return `${lead}${localNorm}`.toLowerCase();
}
